import { render, staticRenderFns } from "./StudentCalendar.vue?vue&type=template&id=18187d1e&scoped=true"
import script from "./StudentCalendar.vue?vue&type=script&lang=js"
export * from "./StudentCalendar.vue?vue&type=script&lang=js"
import style0 from "./StudentCalendar.vue?vue&type=style&index=0&id=18187d1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18187d1e",
  null
  
)

export default component.exports